export const LANGUAGE = {
  ENGLISH: "ENGLISH",
  SPANISH: "SPANISH",
};
